export default {
  email: [
    (value) => !!value || 'El correo electrónico o teléfono es obligatorio'
  ],
  password: [(value) => !!value || 'La contraseña es obligatoria'],
  creditCard: [(value) => !!value || 'Por favor selecciona una tarjeta'],
  cards: {
    fullName: [(value) => !!value || 'El nombre completo es obligatorio'],
    phone: [
      (value) => !!value || 'El teléfono es obligatorio',
      (value) => /^\d{10}$/.test(value) || 'Ingresa tu teléfono a 10 dígitos'
    ],
    email: [
      (value) => !!value || 'El email es obligatorio',
      (value) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        ) || 'Ingresa un correo electrónico válido'
    ],
    name: [(value) => !!value || 'El nombre es obligatorio'],
    city: [(value) => !!value || 'La ciudad es obligatorio'],
    country: [(value) => !!value || 'El país es obligatorio'],
    line1: [(value) => !!value || 'La dirección es obligatoria'],
    postalCode: [(value) => !!value || 'El código postal es obligatorio'],
    state: [(value) => !!value || 'El estado es obligatorio']
  }
}
